<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TAyGhA/tc-custom/9780369700407.jpg?1699985077175" alt="This image is the cover for the book Puppy's Tale"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Puppy's Tale
      </h1>
      <p class="bookDescription body article font2">
        <b>Fall in love with this fan-favorite novella of family, romance and dogs from author Valerie Hansen.</b><br/><br/>Single mom Krista Brody has no problem walking up to a neighbour’s door while searching for her son’s runaway puppy, Puddles. But the stranger who opens the door is very familiar…<br/><br/>Mark Vanbruger hasn’t seen Krista in years, but now they’re living in the same small town. They missed a chance at romance years ago—could a matchmaking puppy help them find happiness as a family now?<br/><br/><i>Originally published in 2003.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Valerie Hansen
      </h2>
      
      <p class="authorDescription body article">Valerie Hansen resides in&#160;the rural Ozarks where she&#160;writes the books of her heart, primarily&#160;for Love Inspired Romance and Suspense. She is married to her childhood sweetheart and&#160;has worked as a teacher&#39;s-aide, EMT, fire dept. dispatcher, dog breeder, commercial artist,&#160;dulcimer builder, Veterinarian&#39;s&#160;asst.,&#160;4-H leader, Sunday School teacher, antique restorer and certified Storm Spotter, etc. See ValerieHansen.com for more!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06445ae9